import { type IngestionTask, IngestionTaskState, IngestionTaskStep } from '@netpurpose/types'
import { convertStringToEnum } from '@netpurpose/utils'
import type { BackendIngestionTask } from './types'

export const parseIngestionTask = (ingestionTask: BackendIngestionTask): IngestionTask => ({
  // Temporarily parsing both IDs until we can drop this function entirely.
  id: ingestionTask.task_id,
  taskId: ingestionTask.task_id,
  batchId: ingestionTask.batch_id,
  entityId: ingestionTask.entity_id,
  state: convertStringToEnum<IngestionTaskState>(ingestionTask.state, IngestionTaskState),
  step: convertStringToEnum<IngestionTaskStep>(ingestionTask.step, IngestionTaskStep),
  priority: ingestionTask.priority,
  theme: ingestionTask.theme,
  phase: ingestionTask.phase,
  years: ingestionTask.years,
  ...(ingestionTask.user_id ? { userId: ingestionTask.user_id } : {}),
  ...(ingestionTask.total_time_spent ? { totalTimeSpent: ingestionTask.total_time_spent } : {}),
  type: ingestionTask.type,
})
